/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AvailabilityModel } from '../../models/availability-model';
import { CalendarEntryRequestModel } from '../../models/calendar-entry-request-model';

export interface ConsumerAvailabilityPractitionerRoleIdPost$Params {
  practitionerRoleId: string;
      body?: CalendarEntryRequestModel
}

export function consumerAvailabilityPractitionerRoleIdPost(http: HttpClient, rootUrl: string, params: ConsumerAvailabilityPractitionerRoleIdPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<AvailabilityModel>> {
  const rb = new RequestBuilder(rootUrl, consumerAvailabilityPractitionerRoleIdPost.PATH, 'post');
  if (params) {
    rb.path('practitionerRoleId', params.practitionerRoleId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<AvailabilityModel>;
    })
  );
}

consumerAvailabilityPractitionerRoleIdPost.PATH = '/Consumer/Availability/{practitionerRoleId}';
